import { z } from 'zod';

const validator = z.boolean().nullable().default(null);

export const PortIsolated = {
    validator,
};
